
import { Component, Vue } from "vue-property-decorator";

import Preloader from "@/components/Preloader.vue";
import CStaffsAndGroupStaffsFactory from "./Factory.vue";
import CStaffsAndGroupStaffsFactoryUec from "./FactoryUec.vue";

import StructureFactory from "@/models/structure/factory";
import structureRoutes from "@/api/routes/structures";
import userRoutes from "@/api/routes/users";
import UserUser from "@/models/user/user";

import { IRouteMeta } from "@/router/interface";

@Component({
  name: "CStaffsAndGroupStaffsStructure",
  components: {
    Preloader,
    CStaffsAndGroupStaffsFactory,
    CStaffsAndGroupStaffsFactoryUec
  }
})
export default class CStaffsAndGroupStaffsStructure extends Vue {
  protected preload: boolean = false;
  protected factories: StructureFactory[] = [];
  protected users: UserUser[] = [];

  private currentUser: IJWTUser | null = this.$store.state.currentUser;

  protected watchers: Function[] = [];

  protected async created() {
    this.preload = true;

    this.watchers.push(
      this.$store.watch(
        state => state.currentUser,
        currentUser => {
          this.currentUser = currentUser;
        }
      )
    );

    this.watchers.push(
      this.$store.watch(
        state => state.editedTreeUser,
        (editedTreeUser: UserUser) => {
          const userIndex = this.users.findIndex(
            u => u.id === editedTreeUser.id
          );

          if (userIndex !== -1) {
            if (editedTreeUser.workplaces?.length) {
              this.$delete(this.users, userIndex);
            } else {
              this.users[userIndex].full_name = editedTreeUser.full_name;
              this.users[userIndex].position_name =
                editedTreeUser.position_name;
              this.users[userIndex].signs = editedTreeUser.signs;
            }
          } else {
            if (!editedTreeUser.workplaces?.length) {
              this.users.push({
                id: editedTreeUser.id,
                full_name: editedTreeUser.full_name,
                email: editedTreeUser.email,
                identification_number: editedTreeUser.identification_number,
                position_name: editedTreeUser.position_name,
                signs: editedTreeUser.signs
              } as UserUser);
            }
          }
        }
      )
    );

    const promises = [];

    if (this.currentUser?.is_developer || this.currentUser?.is_admin) {
      promises.push(this.loadUsers());
    }

    if (this.$api.allowOnlyUserWorkplaces()) {
      promises.push(this.loadFactory());
    } else {
      promises.push(this.loadFactories());
    }

    await Promise.all(promises);

    this.preload = false;
  }

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected async loadFactories() {
    return this.$api
      .get(structureRoutes.factories, {
        params: {
          only_my: true,
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: StructureFactory[] }) => {
        res.forEach(r => (r.is_show = false));

        this.factories = res;
      });
  }

  protected async toggleFactory(factory_index: number) {
    const factory = this.factories[factory_index];

    factory.is_show = !factory.is_show;
  }

  private async loadFactory() {
    return this.$api
      .get(structureRoutes.me_factory)
      .then(({ data: res }: { data: StructureFactory }) => {
        res.is_show = false;

        this.factories = [res];
      });
  }

  protected async loadUsers() {
    return this.$api
      .get(userRoutes.users_tree, {
        params: {
          only_my: true,
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: UserUser[] }) => {
        this.users = res;
      });
  }

  protected async beforeUpdateUser(user_index: number) {
    const user = this.users[user_index];

    this.$store.commit("editTreeUser", {
      id: user.id,
      full_name: user.full_name,
      action: "user"
    });
  }

  protected allowWrite() {
    return this.$api.allowWrite();
  }
}
